module.exports = __webpack_public_path__ + "media/diy-craft.3117dc0e.mp4";